var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.826349 15C0.712156 14.9998 0.599252 14.9758 0.494819 14.9296C0.390386 14.8834 0.296707 14.816 0.219741 14.7316C0.141382 14.6479 0.0815897 14.5486 0.0442838 14.4402C0.00697793 14.3318 -0.00699841 14.2168 0.003271 14.1026L0.204925 11.8846L9.52053 2.56976L12.4318 5.48096L3.11862 14.795L0.90125 14.9967C0.87635 14.999 0.851355 15.0001 0.826349 15ZM13.0129 4.89889L10.1024 1.98769L11.8482 0.241464C11.9246 0.164916 12.0154 0.10419 12.1153 0.0627579C12.2153 0.0213257 12.3224 0 12.4305 0C12.5387 0 12.6458 0.0213257 12.7457 0.0627579C12.8456 0.10419 12.9364 0.164916 13.0129 0.241464L14.7586 1.98769C14.8351 2.06415 14.8958 2.15495 14.9373 2.2549C14.9787 2.35485 15 2.46198 15 2.57018C15 2.67837 14.9787 2.7855 14.9373 2.88545C14.8958 2.9854 14.8351 3.0762 14.7586 3.15266L13.0129 4.89889Z",
    fill: "#D22F31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9062fa3e246dc0cacf3ce50935ea495b.svg";
export { ForwardRef as ReactComponent };